/**
 * メディア（画像・動画）のサムネイル画像URL生成を一元化するユーティリティ。
 *
 * サムネが未生成のケースでは空文字を返し、無効 URL への 404 リクエストを防ぐ。
 * 表示側は `!!url` で描画可否を判定する想定。
 *
 * 未生成の判定:
 *  1. serverRootURL / container / thumbnailName / thumbnailSasToken のいずれか欠落
 *  2. thumbnailName が動画ファイル（= サムネ画像が未生成で動画 blob 名が流用されている）。
 *     バックエンドのエンコードが MK.IO の ThumbnailGeneratorPreset を通しておらず
 *     （例: H264SingleBitrateSD のみ）、thumbnailName に `<id>.mp4` 等が入るケースを弾く。
 */

/** 動画ファイル拡張子（サムネ画像ではないと判定するため）。 */
const VIDEO_EXTENSION = /\.(mp4|mov|m4v|webm|avi|mkv|wmv|flv|ts|m3u8|mpd)$/i;

export interface ThumbnailStorageLike {
  serverRootURL?: string | null;
  container?: string | null;
  thumbnailName?: string | null;
  thumbnailSasToken?: string | null;
  blobName?: string | null;
}

/**
 * 有効なサムネイル画像 URL を生成する。未生成・無効なら空文字を返す。
 */
export function buildMediaThumbnailUrl(
  storage: ThumbnailStorageLike | null | undefined,
): string {
  if (!storage) return '';
  const { serverRootURL, container, thumbnailName, thumbnailSasToken, blobName } = storage;
  if (!serverRootURL || !container || !thumbnailName || !thumbnailSasToken) {
    return '';
  }
  // 実サムネ未生成で動画 blob 名が流用されている場合は表示しない（画像ではないため破損/404）。
  if (thumbnailName === blobName || VIDEO_EXTENSION.test(thumbnailName)) {
    return '';
  }
  return `${serverRootURL}/${container}/${thumbnailName}${thumbnailSasToken}`;
}
